import axios from 'axios'

const apiURL = process.env.REACT_APP_API_URL

export interface ReportUserOption {
  employeeId: number
  employeeName: string
}

/**
 * Who the signed in user may pick on the report user filters, and what those
 * filters start on.
 */
export interface ReportUserScope {
  currentEmployeeId: number
  /** True: filters start empty, meaning all users. False: they start on the current user. */
  canViewAllUsers: boolean
  /** The current user first, then their direct reports (or everybody). */
  employees: ReportUserOption[]
}

export const getReportUserScope = async (): Promise<ReportUserScope> => {
  const token = localStorage.getItem('authToken')

  if (!token) {
    throw new Error('Authorization token not found')
  }

  const response = await axios.get<ReportUserScope>(`https://${apiURL}/Employee/ReportUserScope`, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
  })

  return response.data
}

/**
 * The picked users as repeated employeeIds keys, which is what the API's
 * [FromQuery] List<int> binds from. Nothing picked sends nothing, and the API
 * applies the user's default.
 */
export const appendEmployeeIds = (query: URLSearchParams, employeeIds: number[], key = 'employeeIds') => {
  employeeIds.forEach((id) => query.append(key, String(id)))
  return query
}
